import { render, staticRenderFns } from "./followings-card.vue?vue&type=template&id=51d6a7fa&"
import script from "./followings-card.vue?vue&type=script&lang=js&"
export * from "./followings-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports